module.exports = __webpack_public_path__ + "static/media/res-passport.250a117f.png";